import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import { authApi } from "../api/endpoints";
import { AuthLayout } from "../components/Layout";
import { Alert, Button, TextField } from "../components/ui";
import { useMutation, useDocumentTitle } from "../hooks/useApi";
import { useSession } from "../hooks/SessionContext";

export function LoginPage() {
  useDocumentTitle("Connexion");
  const navigate = useNavigate();
  const { applyState } = useSession();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const login = useMutation(
    () => authApi.login({ email: email.trim(), password }),
    {
      onSuccess: (state) => {
        applyState(state);
        if (!state.twofa_satisfied) navigate("/verification-2fa", { replace: true });
        else if (state.businesses.length === 0) navigate("/bienvenue", { replace: true });
        else navigate("/", { replace: true });
      },
    },
  );

  const locked = login.error?.code === "account_locked";
  const rateLimited = login.error?.code === "rate_limited";

  return (
    <AuthLayout
      title="Connexion"
      intro="Accédez au suivi de vos obligations administratives."
      footer={
        <>
          <Link to="/creer-un-compte">Créer un compte</Link>
          <Link to="/mot-de-passe-oublie">Mot de passe oublié ?</Link>
        </>
      }
    >
      {login.error && (
        <Alert
          tone={locked || rateLimited ? "warning" : "critical"}
          title={
            locked
              ? "Compte temporairement verrouillé"
              : rateLimited
                ? "Trop de tentatives"
                : "Connexion impossible"
          }
        >
          {login.error.message}
        </Alert>
      )}

      <form
        className="mt-4"
        onSubmit={(event) => {
          event.preventDefault();
          void login.run();
        }}
        noValidate
      >
        <TextField
          label="Adresse e-mail"
          type="email"
          autoComplete="username"
          autoCapitalize="none"
          spellCheck={false}
          required
          value={email}
          onChange={(event) => setEmail(event.target.value)}
          error={login.fieldErrors.email}
        />
        <TextField
          label="Mot de passe"
          type="password"
          autoComplete="current-password"
          required
          value={password}
          onChange={(event) => setPassword(event.target.value)}
          error={login.fieldErrors.password}
        />
        <Button type="submit" variant="primary" block loading={login.pending}>
          Se connecter
        </Button>
      </form>
    </AuthLayout>
  );
}
